// 1.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
//   const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];

//   return {
//     Today: formattedCurrentDate,
//     LastWeek: formattedOneWeekAgo,
//   };
// }

// function PrAnalysisTab5() {

//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );

//   const metric = "KW";
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//   };

//   // Fetch inverter list
//   useEffect(() => {

//     async function fetchInverters() {

//       try {

//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: localStorage.getItem("LCODE"),
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];

//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }

//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     }

//     fetchInverters();

//   }, []);

//   // Fetch chart data
//   const fetchChartData = async () => {

//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {

//       let datasets = [];
//       let labels = [];

//       for (const inv of inverters) {

//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.post(
//           `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//           new URLSearchParams({
//             LOGIN_ID: credentials.LOGIN_ID,
//             PASS_KEY: credentials.PASS_KEY,
//             WEB_KEY: credentials.WEB_KEY,
//             MTRNO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           })
//         );

//         const apiData = res.data?.data || [];

//         if (labels.length === 0) {
//           labels = apiData.map((d) => d.DT || "");
//         }

//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d[metric] ?? 0)),

//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),

//           fill: false,
//           tension: 0.3,

//           borderWidth: 1, // thinner line
//           pointRadius: 1, // smaller points
//         });
//       }

//       setChartData({ labels, datasets });

//     } catch (err) {

//       console.log("Chart API error", err);
//       setChartData(null);

//     }

//     setLoading(false);

//   };

//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys]);

//   return (

//     <div style={{ padding: "10px" }}>

//       <Box sx={{ mb: 1 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise Active Power [KW] Comparison
//         </Typography>
//       </Box>

//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>

//         <Box
//           sx={{
//             display: "flex",
//             overflowX: "auto",
//             gap: 2,
//             alignItems: "center",
//             whiteSpace: "nowrap",
//           }}
//         >

//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() =>
//                     handleToggle(inv.feeder_id)
//                   }
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />
//           ))}

//         </Box>

//       </Paper>

//       {/* Filters */}

//       <Box
//         sx={{
//           display: "flex",
//           gap: 1,
//           alignItems: "center",
//           mb: 1,
//         }}
//       >

//         <label>From:</label>

//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) =>
//             setFromDate(e.target.value)
//           }
//         />

//         <label>To:</label>

//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) =>
//             setToDate(e.target.value)
//           }
//         />

//         <TbRefresh
//           style={{
//             fontSize: "1.5rem",
//             cursor: "pointer",
//           }}
//           onClick={fetchChartData}
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName={`Inverter Wise Active Power Comparison.jpeg`}
//         />

//       </Box>

//       {/* Chart */}

//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>

//         {loading ? (
//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             Loading...
//           </Typography>
//         ) : chartData ? (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               scales: {
//                 y: { beginAtZero: true },
//               },
//               plugins: {
//                 legend: { position: "top" },
//               },
//             }}
//           />
//         ) : (
//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             No data available
//           </Typography>
//         )}

//       </Paper>

//     </div>
//   );
// }

// export default PrAnalysisTab5;

// 2,

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend,
} from "chart.js";
import { TbRefresh } from "react-icons/tb";
import {
Paper,
Typography,
Box,
Checkbox,
FormControlLabel,
} from "@mui/material";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import { PrAnalysisTab2Api } from "../../../../../../api/Api";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

ChartJS.register(
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend
);

function getDateTimeForDashboardTab1(date = new Date()) {
const formattedCurrentDate = date.toISOString().split("T")[0];
const oneWeekAgo = new Date(date);
oneWeekAgo.setDate(oneWeekAgo.getDate() - 0);
const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];

return {
Today: formattedCurrentDate,
LastWeek: formattedOneWeekAgo,
};
}

function PrAnalysisTab5() {

const chartRef = useRef();

const [inverters, setInverters] = useState([]);
const [selectedKeys, setSelectedKeys] = useState([]);
const [chartData, setChartData] = useState(null);
const [loading, setLoading] = useState(false);

const [fromDate, setFromDate] = useState(
getDateTimeForDashboardTab1().LastWeek
);
const [toDate, setToDate] = useState(
getDateTimeForDashboardTab1().Today
);

const metric = "KW";

const credentials = {
LOGIN_ID: localStorage.getItem("LoginID"),
LCODE: localStorage.getItem("LCODE"),
PASS_KEY: "XYZ",
WEB_KEY: "WEBXYZ321",
DT1: fromDate,
DT2: toDate
};



// ================= FETCH INVERTER LIST =================

useEffect(() => {

async function fetchInverters() {

try {

const res = await axios.get(
`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
{
params: {
LOGIN_ID: credentials.LOGIN_ID,
LOC_CODE: credentials.LCODE,
PASS_KEY: credentials.PASS_KEY,
WEB_KEY: credentials.WEB_KEY,
TYP: "I",
},
}
);

const feederList = res.data?.FEED || [];

setInverters(feederList);

if (feederList.length > 0) {
setSelectedKeys([feederList[0].feeder_id]);
}

} catch (err) {
console.error("Inverter API Error:", err);
}

}

fetchInverters();

}, []);




// ================= FETCH CHART DATA =================

const fetchChartData = async () => {

if (selectedKeys.length === 0) {
setChartData(null);
return;
}

setLoading(true);

try {

let datasets = [];
let labels = [];


// ===== INVERTER DATA =====

for (const inv of inverters) {

if (!selectedKeys.includes(inv.feeder_id)) continue;

const res = await axios.post(
`${BaseUrl}CMN_08InvLog/post_INV_LOG`,
new URLSearchParams({
LOGIN_ID: credentials.LOGIN_ID,
PASS_KEY: credentials.PASS_KEY,
WEB_KEY: credentials.WEB_KEY,
MTRNO: inv.feeder_id,
DT1: fromDate,
DT2: toDate,
})
);

const apiData = res.data?.data || [];

if (labels.length === 0) {
labels = apiData.map((d) => d.DT || "");
}

datasets.push({
 label: `${inv.name} Active Power [KW]`,
data: apiData.map((d) => parseFloat(d[metric] ?? 0)),
borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
fill: false,
tension: 0.3,
borderWidth: 1,
pointRadius: 1,
});

}



// ===== PLANT PR ANALYSIS DATA =====

const plantRes = await PrAnalysisTab2Api(credentials);

const plantData = plantRes?.data || [];


// Actual Power

datasets.push({
label: "Total Plant Power[kW]",
data: plantData.map((d) => parseFloat(d.POWER ?? 0)),
borderColor: "green",
fill: false,
tension: 0.3,
borderWidth: 2,
pointRadius: 1,
});


// Expected Power

datasets.push({
label: "Irradiance[W/m²]",
data: plantData.map((d) => parseFloat(d.RAD ?? 0)),
borderColor: "#efcc00",
fill: false,
tension: 0.3,
borderWidth: 2,
pointRadius: 1,
});



setChartData({ labels, datasets });

} catch (err) {

console.log("Chart API error", err);
setChartData(null);

}

setLoading(false);

};



const handleToggle = (key) =>
setSelectedKeys((prev) =>
prev.includes(key)
? prev.filter((k) => k !== key)
: [...prev, key]
);


useEffect(() => {
if (selectedKeys.length > 0) {
fetchChartData();
}
}, [selectedKeys]);



return (

<div style={{ padding: "10px" }}>

<Box sx={{ mb: 1 }}>
<Typography variant="h5" fontWeight="bold">
Power Performance
</Typography>
</Box>


<Paper elevation={2} sx={{ p: 2, mb: 2 }}>

<Box
sx={{
display: "flex",
overflowX: "auto",
gap: 2,
alignItems: "center",
whiteSpace: "nowrap",
}}
>

{inverters.map((inv) => (
<FormControlLabel
key={inv.feeder_id}
control={
<Checkbox
checked={selectedKeys.includes(inv.feeder_id)}
onChange={() => handleToggle(inv.feeder_id)}
/>
}
label={`${inv.name} [${inv.kwp} kWp]`}
/>
))}

</Box>

</Paper>


<Box
sx={{
display: "flex",
gap: 1,
alignItems: "center",
mb: 1,
}}
>

<label>From:</label>

<input
type="date"
value={fromDate}
onChange={(e) => setFromDate(e.target.value)}
/>

<label>To:</label>

<input
type="date"
value={toDate}
onChange={(e) => setToDate(e.target.value)}
/>

<TbRefresh
style={{
fontSize: "1.5rem",
cursor: "pointer",
}}
onClick={fetchChartData}
/>

<DownloadJpegButton
targetRef={chartRef}
fileName={`Inverter Wise Active Power Comparison.jpeg`}
/>

</Box>


<Paper ref={chartRef} sx={{ p: 2, height: 350 }}>

{loading ? (
<Typography sx={{ textAlign: "center", mt: 12 }}>
Loading...
</Typography>
) : chartData ? (
<Line
data={chartData}
options={{
responsive: true,
maintainAspectRatio: false,
scales: {
y: { beginAtZero: true },
},
plugins: {
legend: { position: "top" },
},
}}
/>
) : (
<Typography sx={{ textAlign: "center", mt: 12 }}>
No data available
</Typography>
)}

</Paper>

</div>

);

}

export default PrAnalysisTab5;